import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import logo from "./images/logo.jpg";
import "./App.css";
import useFetch from "./hooks/useFetch";

function App() {
  const { data, error, loading, setFetch } = useFetch(
    `${process.env.REACT_APP_API_BASE_URL}/data/items`
  );

  console.log(data);
  return (
    <div className="elementor elementor-9" style={{ marginBottom: "200px" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <img src={logo} height="100" width="200" />
      </div>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-3ec1020 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="3ec1020"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-default elementor-column-gap-default-categories">
          {data?.map((category, index) => (
            <a
              key={index}
              href={`#${category.name}`}
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-085851b"
              style={{ textDecoration: "none" }}
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-element elementor-element-0948721 elementor-widget elementor-widget-image">
                  {/* <div className="elementor-widget-container"> */}
                  <img
                    decoding="async"
                    width={"80"}
                    height={"80"}
                    src={`${process.env.REACT_APP_API_BASE_URL_ATTACHMENTS}/images/${category.image}`}
                    className="attachment-large size-large wp-image-31"
                    alt=""
                    loading="lazy"
                  />
                  {/* </div> */}
                </div>
                <div className="elementor-element elementor-element-5bb1d79 elementor-widget elementor-widget-heading">
                  <div className="elementor-widget-container">
                    <h5 className="elementor-heading-title elementor-size-default">
                      {category.name}
                    </h5>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-da2e144 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="da2e144"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-default">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7d98875"
            data-id="7d98875"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-b6f59b5 elementor-widget elementor-widget-spacer"
                data-id="b6f59b5"
                data-element_type="widget"
                data-widget_type="spacer.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {data?.map((category, index) => (
        <>
          <section
            id={`${category.name}`}
            className="elementor-section elementor-top-section elementor-element elementor-element-a9702f1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          >
            <div
              className="elementor-container elementor-column-gap-default"
              style={{ display: "flex", alignItems: "end" }}
            >
              <div
                className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-5992c8c"
                // style={{ width: "fit-content" }}
              >
                {/* <div className="elementor-widget-wrap elementor-element-populated"> */}
                {/* <div className="elementor-element elementor-element-c3bfc25 elementor-widget elementor-widget-image"> */}
                {/* <div className="elementor-widget-container"> */}
                <img
                  decoding="async"
                  width={"80"}
                  height={"80"}
                  src={`${process.env.REACT_APP_API_BASE_URL_ATTACHMENTS}/images/${category.image}`}
                  className="attachment-large size-large wp-image-31"
                  alt=""
                  loading="lazy"
                />{" "}
                {/* </div> */}
                {/* </div> */}
                {/* </div> */}
              </div>
              <div className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-d162f2d">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-274e728 elementor-widget elementor-widget-heading">
                    <div
                      className="elementor-widget-container"
                      style={{ textAlign: "center" }}
                    >
                      <h4 className="elementor-heading-title elementor-size-default">
                        {category.name}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-9ae18d8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="9ae18d8"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c1f85a3"
                data-id="c1f85a3"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  {category?.items?.map((item, index) => (
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-bae002a elementor-section-boxed elementor-section-height-default elementor-section-height-default">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-cdc64fb">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-52c935f elementor-widget elementor-widget-image">
                              <div className="elementor-widget-container">
                                <img
                                  decoding="async"
                                  width="683"
                                  height="1024"
                                  src={`${process.env.REACT_APP_API_BASE_URL_ATTACHMENTS}/images/${item.image}`}
                                  className="attachment-large size-large wp-image-34"
                                  alt=""
                                  loading="lazy"
                                />{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-66 elementor-inner-column elementor-element elementor-element-fde957d">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-ba893be elementor-widget elementor-widget-heading">
                              <div className="elementor-widget-container">
                                <h4 className="elementor-heading-title elementor-size-default">
                                  {item.name}
                                </h4>{" "}
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-f561247 elementor-widget elementor-widget-text-editor">
                              <div className="elementor-widget-container">
                                {/* <p>{item.description}</p>{" "} */}

                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-47c7f66 elementor-widget elementor-widget-heading">
                              <div
                                className="elementor-widget-container"
                                style={{ marginBottom: 10 }}
                              >
                                <h5
                                  className="elementor-heading-title elementor-size-default"
                                  style={{ display: "flex", fontSize: 20 }}
                                >
                                  {item?.label1 && item?.label1 != "null" && (
                                    <span
                                      style={{
                                        color: "grey",
                                        width: "60px",
                                        display: "block",
                                      }}
                                    >
                                      {" "}
                                      {item?.label1}
                                    </span>
                                  )}{" "}
                                  {item?.price1 &&
                                    item?.price1 != "null" &&
                                    item?.price1}
                                </h5>
                              </div>

                              <div
                                className="elementor-widget-container"
                                style={{ marginBottom: 10 }}
                              >
                                <h5
                                  className="elementor-heading-title elementor-size-default"
                                  style={{ display: "flex", fontSize: 20 }}
                                >
                                  {item?.label2 && item?.label2 != "null" && (
                                    <span
                                      style={{
                                        color: "grey",
                                        width: "60px",
                                        display: "block",
                                      }}
                                    >
                                      {" "}
                                      {item?.label2}
                                    </span>
                                  )}{" "}
                                  {item?.price2 &&
                                    item?.price2 != "null" &&
                                    item?.price2}{" "}
                                </h5>
                              </div>
                              <div
                                className="elementor-widget-container"
                                style={{ marginBottom: 10 }}
                              >
                                <h5
                                  className="elementor-heading-title elementor-size-default"
                                  style={{ display: "flex", fontSize: 20 }}
                                >
                                  {item?.label3 && item?.label3 != "null" && (
                                    <span
                                      style={{
                                        color: "grey",
                                        width: "60px",
                                        display: "block",
                                      }}
                                    >
                                      {" "}
                                      {item?.label3}
                                    </span>
                                  )}{" "}
                                  {item?.price3 &&
                                    item?.price3 != "null" &&
                                    item?.price3}{" "}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </>
      ))}
    </div>
  );
}

export default App;
